import { render, staticRenderFns } from "./High_floor.vue?vue&type=template&id=17f20684"
import script from "./High_floor.vue?vue&type=script&lang=js"
export * from "./High_floor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports